import { EdgeUpdateMyProfileRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { UpdateMyProfile } from '@/modules/auth/use-cases'

export function makeUpdateMyProfile(): UpdateMyProfile {
  return new EdgeUpdateMyProfileRepository(makeSupabaseEdgeHttpClient()).execute
}
